import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Journal, Author } from 'src/app/shared/models/user';

@Component({
  selector: 'app-profile-journal',
  templateUrl: './profile-journal.component.html',
  styleUrls: ['./profile-journal.component.scss']
})
export class ProfileJournalComponent implements OnInit {
  @Input() journals = new BehaviorSubject<Journal[]>([]);
  journalsClean = new BehaviorSubject<Journal[]>([]);
  yearOrder: number = 2;
  searchField: string;
  page = 1;
  pageSize = 10;

  constructor() { }

  ngOnInit(): void {
    this.journalsClean = this.journals;
  }

  formatAuthorName(author: Author): string {
    if (author.middleInitial != null && author.middleInitial.trim().length > 0) {
      return ` ${author.firstName}, ${author.lastName} ${author.middleInitial} `;
    } else {
      return ` ${author.firstName}, ${author.lastName} `;
    }
  }

  onSearchChange(searchValue: string) : void{
    let tempJournals = [];
    if(searchValue.length > 0)
    {
      this.journalsClean.forEach(journals => {
        if(journals.length > 0)
        {
          journals.forEach(journal => {
            if(journal.title.includes(searchValue))
            {
              // Set journal list to filtered journal list
              tempJournals.push(journal);
              this.journals = new BehaviorSubject<Journal[]>(tempJournals);
            }
          });
        }
      })
    }
    else {
      // Set journal list to full journal list
      this.journals = this.journalsClean;
    }
  }
  
}
